import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/block/prefix';

export default {
    getBlockList(page, size, sort) {
        const params = {
            'page' : page,
            'size' : size,
            'sort' : sort
        }
        return axios.get(BASE_URL, { params: params});
    },

    getBlockedPrefix(prefixId) {
        return axios.get(BASE_URL + "/" + prefixId);
    },

    addBlockedPrefix(prefix, editor) {
        return axios.post(BASE_URL,
            {
                "prefix": prefix,
                "editor": editor,
            })
    },

    updateBlockedPrefix(id, prefix, editor) {
        return axios.put(BASE_URL + '/' + id,
            {
                "prefix": prefix,
                "editor": editor,
            })
    },

    deleteBlockedPrefix(prefixId) {
        return axios.delete(BASE_URL + '/' + prefixId);
    }
}